export * from './playlist.component';

export const PlaylistTemplate = require('./playlist.component.hbs');
